export default {
  userPermissions: {},
  ignore: 0
}